import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
import { Table } from 'antd'
const { WizSpin, WizButton, WizCard, WizModalForm } = component_tool
const { WizContainer } = framework_tool
const { Session } = utils_tool

import CounselingHeader from '../header'

const findParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/integrationCounseling/manager/onlineNotification/administratorSetting') {
        if (history.location && history.location.record) {
            record = history.location.record || {}
            Session.set('administratorSetting', record)
        } else {
            record = Session.get('administratorSetting') || {}
        }
    }
    return record
}

const reg = new RegExp('^[0-9]{11,12}$')

class AdministratorSetting extends WizContainer {

    componentName = 'AdministratorSetting'

    constructor(props) {
        super(props)
        let record = findParamRecord(props.history)
        this.state = {
            record,
            visible: false,
            formRecord: null
        }
    }

    _componentDidMount() {
        this._list()
    }

    _list = () => {
        const { processContentId } = this.state.record
        this.doAction({
            path: 'counselingProcess/dealerManager',
            payload: {
                key: 'dealerManager@' + processContentId,
                apiParams: {
                    tutorContentId: processContentId
                }
            }
        })
    }

    propsAndStateOnChange = {
        list: this._listOnChange.bind(this),
        save: this._saveOnChange.bind(this),
    }

    _listOnChange(nextProps, nextState) {
        if (nextProps.list && nextProps.list.code === 1) {
            nextState.formRecord = nextProps.list.data[0]
        } else {
            wizNotice.error(nextProps.list.msg)
        }
        return true
    }

    _saveOnChange(nextProps, nextState) {
        if (nextProps.save && nextProps.save.code === 1) {
            this._list()
            nextState.visible = false 
            wizNotice.success('操作成功')
        } else {
            wizNotice.error(nextProps.save.msg)
        }
        return true
    }

    _submit = (values = {}) => {
        const { processContentId } = this.state.record
        this.doAction({
            path: 'counselingProcess/setDealerManager',
            payload: {
                key: 'setDealerManager@' + processContentId,
                apiParams: {
                    tutorContentId: processContentId,
                    ...values
                }
            }
        })
    }

    render() {
        let { record, visible, formRecord } = this.state
        let { list, counselingProcessLoading } = this.props
        let columns = [{
            title: '执行内容',
            name: 'content',
            dataIndex: 'content'
        }, {
            title: '姓名',
            name: 'fullName',
            dataIndex: 'fullName',
            formItem: {
                rules: [{ required: true, message: '请输入姓名' }]
            }
        }, {
            title: '手机号',
            name: 'mobile',
            dataIndex: 'mobile',
            formItem: {
                rules: [
                    { required: true, message: '请输入手机号' },
                    { pattern: reg, message: '手机号码有误，请填入正确的手机号码' }
                ]
            }
        }, {
            title: '系统管理员账号',
            name: 'userName',
            dataIndex: 'userName',
            formItem: {
                maxLength: 20
            }
        }, {
            title: '密码',
            name: 'password',
            dataIndex: 'password',
            formItem: {
                maxLength: 20
            }
        }, {
            title: '操作',
            name: 'operation',
            dataIndex: 'operation',
            align: 'center',
            width: 120,
            render: () => {
                let buttonProps = {
                    type: 'link',
                    onClick: () => this.setState({ visible: true })
                }
                return <WizButton {...buttonProps}>{'设置'}</WizButton>
            }
        }]

        let tableProps = {
            columns,
            dataSource: list.data || [],
            pagination: false,
            bordered: true,
            rowKey: 'id'
        }
        let formProps = {
            record: formRecord,
            visible,
            columns,
            modalOpts: { width: 700 },
            onCancel: () => this.setState({ visible: false }),
            onSubmit: values => this._submit(values)
        }
        return (
            <WizSpin spinning={counselingProcessLoading} >
                <CounselingHeader record={record} />
                <WizCard title='经销商系统管理员'>
                    <WizModalForm {...formProps} />
                    <Table {...tableProps} />
                </WizCard>
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { counselingProcess } = state
    const { processContentId } = findParamRecord(ownProps.history)
    const list = modelUtils.getModelEntity(counselingProcess, 'dealerManager@' + processContentId)
    const save = modelUtils.getModelEntity(counselingProcess, 'setDealerManager@' + processContentId)
    const loading = modelUtils.getLoadingState(state, 'counselingProcess')
    return {
        list,
        save,
        ...loading
    }
}

export default connect(mapStateToProps)(AdministratorSetting)


